// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1N-4g","overflowing":"ReadFullNote_overflowing__2v6Op"};